import styled from "styled-components";

const ZePrimaryButton = styled.button.attrs({
  className: "btn btn-primary"
})``;

export default ZePrimaryButton;
